export default __webpack_public_path__ + "media/images/banner/banner-15-8fdc9358b5db689388100838ab5905ee.jpg";